import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tier",
  "use": "icon-icon-tier-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-tier\"><!--Generator: Adobe Illustrator 29.0.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 186)--><rect x=\"213.49\" y=\"63.95\" width=\"298.51\" height=\"298.51\" /><rect x=\"512\" y=\"362.46\" width=\"298.51\" height=\"298.51\" /><rect x=\"213.49\" y=\"660.97\" width=\"298.51\" height=\"298.51\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol